var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isBlank)?_c('div',_vm._l((_vm.value),function(item){return _c('app-list-item-relation-to-one',{key:item.id,attrs:{"permission":_vm.permission,"url":_vm.url,"value":item}})}),1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }